export const CONS = {
  title: 'Locked Out',
  header: 'There were too many incorrect attempts',
  noMatchFound: 'No match found',
  lockedContinueMessage:
    'We couldn’t connect your prescription records this time. But, you can still link your CVS account to DoorDash so you’re all set for future prescriptions.',
  continue: 'Continue',
  lockSearchMessage:
    'The information you entered does not match what we have on file, or you have not previously used our services.',
  lockMessage1: 'To help keep this account secure, you will have to wait until ',
  lockMessage2: ' to try again.',
  lockMessage3: 'The info entered doesn\'t match what we have on file.',
  customerCareMessage1: 'Or call Customer Care to verify',
  customerCareMessage2: 'To finish verifying your identity, call us at ',
  backToAddAndManagePeople: 'Back to add and manage people',
  backToCvs: 'Back to CVS.com',
  backToHome: 'Return to the home page',
  HD1: 'HD1 error.',
  customerCare: '1-888-607-4287',
  TTY: ' (TTY: ',
  TTYNo: '711',
  customerCareMessage3: ') and tell them you have a '
};

// Translation configuration for locked page
export const LOCKED_TRANSLATION_CONFIG = [{ key: 'CONS', value: CONS, message: JSON.stringify(CONS) }];

// Helper function to process translated items
export const processLockedTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  const parsedCons = translatedItems[JSON.stringify(CONS)];
  let consTranslated = CONS;

  if (parsedCons) {
    try {
      consTranslated = typeof parsedCons === 'string' ? JSON.parse(parsedCons) : parsedCons;
    } catch {
      consTranslated = CONS;
    }
  }

  return {
    CONS: consTranslated
  };
};
